import makeStyles from "@mui/styles/makeStyles";
import { sharedNotificationStyles, notificationColors } from "./sharedStyles";

const useStyles = makeStyles(() => ({
  phoneContainer: {
    position: "relative",
    width: "100%",
    height: "368px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "20px",
    overflow: "hidden",
    clipPath: "inset(0)",
  },
  phoneFrame: {
    position: "relative",
    width: "100%",
    maxWidth: "356.775px",
    height: "auto",
    aspectRatio: "356.775 / 737",
    backgroundColor: "#000000",
    borderRadius: "56.112px",
    border: "5.025px solid #292826",
    padding: "10.05px 8.38px",
    boxSizing: "border-box",
    transformOrigin: "top center",
    overflow: "hidden",
  },
  phoneScreen: {
    width: "100%",
    height: "100%",
    backgroundColor: "#FFFFFF",
    borderRadius: "41.037px",
    overflow: "hidden",
    position: "relative",
  },
  statusBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "49.412px",
    padding: "0 13.4px",
    backgroundColor: "transparent",
  },
  statusBarLeft: {
    display: "flex",
    alignItems: "center",
    fontSize: "13.4px",
    fontWeight: 600,
    fontFamily: "SF Pro Text, sans-serif",
    color: "#000000",
    letterSpacing: "-0.32px",
  },
  statusBarRight: {
    display: "flex",
    alignItems: "center",
    gap: "6.7px",
  },
  statusBarIcon: {
    width: "15.075px",
    height: "10.05px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dynamicIsland: {
    position: "absolute",
    top: "8px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "104.687px",
    height: "30.987px",
    backgroundColor: "#000000",
    borderRadius: "100px",
    zIndex: 10,
  },
  notificationBanner: {
    position: "absolute",
    top: "60px",
    left: "13.4px",
    right: "13.4px",
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    padding: "10.05px 13.4px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    border: "0.5px solid rgba(0, 0, 0, 0.1)",
    zIndex: 20,
    display: "flex",
    flexDirection: "column",
    gap: "6.7px",
  },
  notificationHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8.38px",
  },
  notificationIcon: {
    width: "33.5px",
    height: "33.5px",
    borderRadius: "8px",
    backgroundColor: "#E4E7EC",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  notificationHeaderContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "2.09px",
    minWidth: 0,
  },
  notificationAppName: {
    fontFamily: "SF Pro Text, sans-serif",
    fontSize: "11.72px",
    fontWeight: 600,
    color: "#000000",
    letterSpacing: "-0.28px",
    lineHeight: "13.4px",
  },
  notificationTimestamp: {
    fontFamily: "SF Pro Text, sans-serif",
    fontSize: "10.05px",
    color: "rgba(60, 60, 67, 0.6)",
    letterSpacing: "-0.24px",
    lineHeight: "12.55px",
  },
  notificationTitle: {
    fontFamily: "SF Pro Text, sans-serif",
    fontSize: "13.4px",
    fontWeight: 600,
    color: "#000000",
    letterSpacing: "-0.32px",
    lineHeight: "16.75px",
    marginTop: "2.09px",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
  },
  notificationBody: {
    fontFamily: "SF Pro Text, sans-serif",
    fontSize: "12.55px",
    color: "rgba(60, 60, 67, 0.8)",
    letterSpacing: "-0.3px",
    lineHeight: "16.75px",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    color: "rgba(60, 60, 67, 0.6)",
    fontFamily: "Manrope, sans-serif",
    fontSize: "14px",
    padding: "40px 20px",
  },
  webContainer: {
    position: "relative",
    width: "100%",
    height: "368px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    overflow: "visible",
  },
  webNotificationPanel: sharedNotificationStyles.webNotificationPanel,
  bellIconContainer: sharedNotificationStyles.bellIconContainer,
  bellBadge: sharedNotificationStyles.bellBadge,
  notificationsPanelContent: sharedNotificationStyles.notificationsPanelContent,
  webPanelHeader: sharedNotificationStyles.webPanelHeader,
  unreadBadge: sharedNotificationStyles.unreadBadge,
  markAllRead: {
    ...sharedNotificationStyles.markAllRead,
    "&:hover": {
      textDecoration: "underline",
    },
  },
  webNotificationItem: sharedNotificationStyles.webNotificationItem,
  webNotificationDot: sharedNotificationStyles.webNotificationDot,
  webNotificationTitle: sharedNotificationStyles.webNotificationTitle,
  webNotificationContent: sharedNotificationStyles.webNotificationContent,
  webNotificationTime: sharedNotificationStyles.webNotificationTime,
  webNotificationPin: {
    ...sharedNotificationStyles.closeButton,
    width: "16px",
    height: "16px",
    flexShrink: 0,
    cursor: "pointer",
  },
  seeAllNotifications: {
    ...sharedNotificationStyles.seeAllNotifications,
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export default useStyles;

